import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import PulseLoader from '../../../components/PulseLoader';
import logo from '../../../PINS.png';

import ProjectRecordsContainer from './ProjectRecordsContainer';

const ProjectRecordsSidePanel = ({ procoreCompanyId, procoreProjectId }) => (
  <Box
    bg="background.main"
    height="100%"
    minHeight="100vh"
    padding={4}
  >
    <HStack mb={6} spacing={2}>
      <img alt="PINS Advantage Logo" src={logo} style={{ height: '40px', width: 'auto', marginRight: '10px' }} />
      <Text textStyle="displayXxs">Compliance Report</Text>
    </HStack>

    {(procoreCompanyId && procoreProjectId)
      ? (
        <ProjectRecordsContainer
          procoreCompanyId={procoreCompanyId}
          procoreProjectId={procoreProjectId}
        />
      ) : (
        <>
          <Text>Waiting to receive Procore company and project ids...</Text>
          <PulseLoader />
        </>
      )}
  </Box>
);

ProjectRecordsSidePanel.propTypes = {
  procoreCompanyId: PropTypes.number.isRequired,
  procoreProjectId: PropTypes.number.isRequired
};

export default ProjectRecordsSidePanel;
